import React from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import LockResetIcon from "@mui/icons-material/LockReset";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "context/TranslationProvider";
import { useAuth } from "context/AuthContext";

const UserActions = ({
  row,
  currentUserId,
  onView,
  onDelete,
  onReset,
  onEdit,
  isLoading,
}) => {
  const { t, language } = useTranslation();
  const { permission } = useAuth();
  const canUser = permission?.permissions?.modules?.users || {};

  const isDeleted = row?.isDeleted;

  const getTooltip = (defaultText) =>
    isDeleted ? t("page.users.actions.userDeleted", "User is deleted") : defaultText;

  return (
    <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-1 w-100">

      {/* VIEW */}
      {onView && (
        <>
          <Button
            id={`view-${row._id}`}
            size="sm"
            onClick={() => !isDeleted && canUser?.read && onView(row)}
            disabled={!canUser?.read || isDeleted || isLoading}
          >
            <VisibilityIcon fontSize="small" color="primary" />
          </Button>

          <UncontrolledTooltip
            key={`view-${row._id}-${language}`}
            target={`view-${row._id}`}
          >
            {getTooltip(t("page.users.actions.view", "View Details"))}
          </UncontrolledTooltip>
        </>
      )}

      {/* EDIT */}
      {onEdit && row._id !== currentUserId && (
        <>
          <Button
            id={`edit-${row._id}`}
            size="sm"
            onClick={() => !isDeleted && canUser?.update && onEdit(row)}
            disabled={!canUser?.update || isDeleted || isLoading}
          >
            <EditIcon fontSize="small" color="info" />
          </Button>

          <UncontrolledTooltip
            key={`edit-${row._id}-${language}`}
            target={`edit-${row._id}`}
          >
            {getTooltip(t("page.users.actions.edit", "Edit User"))}
          </UncontrolledTooltip>
        </>
      )}

      {/* DELETE */}
      {onDelete && (
        <>
          <Button
            id={`delete-${row._id}`}
            size="sm"
            disabled={
              row?.status === "resolved" ||
              !canUser?.delete ||
              isDeleted ||
              isLoading
            }
            onClick={() => !isDeleted && canUser?.delete && onDelete(row)}
          >
            <DeleteIcon fontSize="small" color="error" />
          </Button>

          <UncontrolledTooltip
            key={`delete-${row._id}-${language}`}
            target={`delete-${row._id}`}
          >
            {getTooltip(t("page.users.actions.delete", "Delete User"))}
          </UncontrolledTooltip>
        </>
      )}

      {/* RESET PASSWORD */}
      {onReset && (
        <>
          <Button
            id={`reset-${row._id}`}
            size="sm"
            disabled={
              row?.status === "resolved" ||
              !canUser?.update ||
              isDeleted ||
              isLoading
            }
            onClick={() => !isDeleted && canUser?.update && onReset(row)}
          >
            <LockResetIcon fontSize="small" color="primary" />
          </Button>

          <UncontrolledTooltip
            key={`reset-${row._id}-${language}`}
            target={`reset-${row._id}`}
          >
            {getTooltip(t("page.users.actions.resetPassword", "Reset Password"))}
          </UncontrolledTooltip>
        </>
      )}
    </div>
  );
};

export default UserActions;